import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fcp-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.scss']
})
export class BadgesComponent implements OnInit {
  @Input() links: any;
  @Input() badges: any;

  constructor() {}

  ngOnInit() {}
}
